export default "/images/framework/Background.0cba1cd5.svg?0cba1cd5";